import JsDownload from 'js-file-download';
import { parse } from 'json2csv';

export default (data, fields, filename = 'download.csv') => {
  const csvInfo = parse(data, { fields });
  JsDownload(csvInfo, filename);
};
